/**
 * @desc: - 增强版音频控制器
 * @author: ammo
 */

import React from 'react';


export default class AudioPlus extends React.Component {

  constructor(props) {
    super(props);
  }

  // 完成状态变更后
  componentDidUpdate(){
    const { notice, play, times, stopFn } = this.props;
    let superAudio = document.getElementById('super-audio');
    // 没有播放
    if (!play || !notice) {
      return;
    }
    // 开始播放
    superAudio.play();
  }

  render() {
    const { mp3, wav } = this.props;
    return (
      <audio id='super-audio'>
        {
          mp3 ? <source src={mp3} type='audio/mpeg' /> : null
        }
        {
          wav ? <source src={wav} type='audio/wav' /> : null
        }
      </audio>
    );
  }
}

